var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "js-main-content" },
    [
      _vm.isHeroBannerEnabled ? _c("home-hero-banner") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "gfu-homepage-wrapper _grid _grid-cols-1 _grid-cols-24--l _grid-cols-24--xl _row-gap-6",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "_col-span-1 _col-span-5--l _col-span-4--xl _flexcol _ai-st _order-7 _order-1--l",
            },
            [
              !_vm.isLaunchCampaignBoxEnabled
                ? _c(
                    "section",
                    {
                      staticClass: "_flexcol _grow-1",
                      attrs: {
                        role: "region",
                        "aria-labelledby": "home-project-lists-title",
                      },
                    },
                    [
                      _c(
                        "home-section-title",
                        {
                          staticClass: "_mb-3",
                          attrs: {
                            id: "home-project-lists-title",
                            "icon-name": "grid-horizontal",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.Resources.Homepage.ProjectListsSectionTitle
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("home-project-list"),
                    ],
                    1
                  )
                : _c("home-project-list"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "_col-span-1 _col-span-13--l _col-span-15--xl gfu-homepage-featured-projects _order-1 _order-2--l",
              attrs: { role: "region", "data-qa": "homepage-section:Featured" },
            },
            [_c("featured-projects")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "_col-span-1 _col-span-6--l _col-span-5--xl _flexcol _ai-st _order-2 _order-3--l",
              attrs: {
                role: "region",
                "aria-labelledby": "home-spotlight-title",
                "data-qa": "homepage-section:Spotlight",
              },
            },
            [
              _c(
                "home-section-title",
                {
                  staticClass: "_mb-3",
                  attrs: {
                    id: "home-spotlight-title",
                    "icon-name": "lighthouse",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.Resources.Homepage.SpotlightSectionTitle) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("spotlight"),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasBanner
            ? _c(
                "div",
                {
                  staticClass:
                    "_col-span-1 _col-span-24--l _order-3 _order-4--l",
                  attrs: { role: "region" },
                },
                [
                  _c("announcements", {
                    attrs: {
                      "preview-banner-id": _vm.previewBannerId,
                      "data-qa": "home-page-box:InfoBanners",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "_col-span-1 _col-span-24--l _order-5 _order-6--l",
              attrs: { role: "region", "data-qa": "homepage-section:Explore" },
            },
            [_c("explore-projects-section")],
            1
          ),
          _vm._v(" "),
          _vm.isRankingEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "_col-span-1 _col-span-24--l _order-4 _order-5--l",
                  attrs: {
                    role: "region",
                    "aria-labelledby": "home-rankings-title",
                    "data-qa": "homepage-section:Rankings",
                  },
                },
                [
                  _c("projects-ranking", {
                    attrs: { "default-category": _vm.rankingsDefaultCategory },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "home-section-title",
                                {
                                  attrs: {
                                    id: "home-rankings-title",
                                    "icon-name": "trophy",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.Resources.Homepage
                                          .RankingsSectionTitle
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1524113372
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "_col-span-1 _col-span-24--l _order-8",
              attrs: { role: "region" },
            },
            [_c("home-platform-statistics")],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }